const Linkedin = ({ bg_color = "#335D74", fg_color = "#FFFEFC", className = "" }) => (
  <svg
    className={`shrink-0 ${className}`}
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect width="25" height="25" rx="5" fill={bg_color} />
    <path
      d="M21 13.8096V20H17.3562V14.224C17.3562 12.7727 16.829 11.7827 15.5105 11.7827C14.5037 11.7827 13.9041 12.4505 13.6409 13.0956C13.5447 13.3263 13.52 13.6477 13.52 13.9706V20H9.87449C9.87449 20 9.92389 10.2181 9.87449 9.20386H13.52V10.7341L13.4961 10.7693H13.52V10.7341C14.0038 10 14.8683 8.9505 16.8043 8.9505C19.202 8.9505 21 10.4941 21 13.8096ZM6.06208 4C4.81597 4 4 4.80537 4 5.86493C4 6.90101 4.79212 7.73071 6.01438 7.73071H6.03823C7.30989 7.73071 8.09945 6.90101 8.09945 5.86493C8.07731 4.80537 7.30989 4 6.06208 4ZM4.21634 20H7.86011V9.20386H4.21634V20Z"
      fill={fg_color}
    />
  </svg>
);

export default Linkedin;
